import React from 'react';
import classNames from 'classnames';
import { Icon } from 'ui';

class SmartGroupsList extends React.Component {
  constructor(props) {
    super(props);
    this.setActiveGroup = this.setActiveGroup.bind(this);
  }

  setActiveGroup() {
    this.props.updateActiveGroup(this.props.group.id);
    this.props.updateMyOrganization(false);
    if (this.props.groupsListVisible) {
      this.props.toggleGroupsList();
    }
  }

  render() {
    const { group, activeGroup } = this.props;
    const invalidGroup = group.recalculationState === 'invalid';

    const liStyle = classNames(
      'NestedList-item',
      'CustomColor--borderColorLeft',
      'NestedList--hoverStyles',
      {
        'mb-12': true,
        'NestedList-item--active fw-b':
          Number(activeGroup) === Number(group.id),
      },
    );

    return (
      /* eslint jsx-a11y/no-noninteractive-element-interactions: 0, jsx-a11y/click-events-have-key-events: 0 */
      <li className={liStyle} onClick={this.setActiveGroup}>
        {invalidGroup && (
          <Icon name="warning_sign" className="c-brand-red mr-4" />
        )}
        {group.name}
        {group.calculating && (
          <span className="NestedList-subtitle">
            {t('smart_groups.calculating_sidebar')}
          </span>
        )}
      </li>
    );
  }
}

export default SmartGroupsList;
